import { PageHero, CTASection } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { CAPABILITIES_FULL, IMAGES } from "@/lib/data";

export default function Capabilities() {
  return (
    <div>
      <PageHero index="02 — Capabilities" title={<>Engineered to<br />Your Spec.</>} subtitle="Full-spectrum pattern manufacturing, tooling and machining under one roof." image={IMAGES.cncSparks} />

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-[#DCE1E8]">
          {CAPABILITIES_FULL.map((c, i) => (
            <Reveal key={i} delay={(i % 3) * 0.05}>
              <div className="group border-r border-b border-[#DCE1E8] bg-white p-8 lg:p-10 h-full hover:bg-[#F4F6F9] transition-colors duration-300" data-testid={`capability-full-${i}`}>
                <div className="flex items-start justify-between">
                  <div className="font-mono text-xs text-[#1D4ED8]">{String(i + 1).padStart(2, "0")}</div>
                  <ArrowUpRight size={18} className="text-slate-400 group-hover:text-[#1D4ED8] transition-colors duration-300" />
                </div>
                <h3 className="font-display font-bold text-2xl tracking-tight mt-8 leading-tight text-[#0E1626]">{c.title}</h3>
                <p className="text-slate-600 font-light mt-4 leading-relaxed">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
